var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExperimentImaged(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6441_460032)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 19.165C7.2252 19.7005 8.57738 20 10 20C10.5024 20 10.996 19.9612 11.4785 19.8896V24H6V19.165ZM17.7393 24H12.2607V19.7402C13.3272 19.4937 14.3288 19.0789 15.2344 18.5215H17.7393V24ZM24 24H18.5215V18.5215H24V24ZM24 17.7393H18.5215V15.2334C19.0787 14.328 19.4938 13.327 19.7402 12.2607H24V17.7393ZM17.7393 17.7393H16.333C16.8472 17.318 17.3181 16.8462 17.7393 16.332V17.7393ZM24 11.4785H19.8906C19.9621 10.996 20 10.5024 20 10C20 8.57738 19.7005 7.2252 19.165 6H24V11.4785Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10.5,
    fill: "#FEFEFE",
    stroke: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 6.33333C5 5.59695 5.59695 5 6.33333 5H15.6667C16.403 5 17 5.59695 17 6.33333V15.6667C17 16.403 16.403 17 15.6667 17H6.33333C5.59695 17 5 16.403 5 15.6667V6.33333Z",
    fill: "#2A83F7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 6.33333C5 6.03333 6.03333 5 6.33333 5H15.6667C15.9667 5 17 5.9 17 6.2V15.6667C17 15.9667 15.9667 17 15.6667 17H6.33333C6.03333 17 5 15.9667 5 15.6667V6.33333ZM16.4 14.6V6.2C16.4 5.9 16.1 5.6 15.8 5.6H6.2C5.9 5.6 5.6 5.9 5.6 6.2V14.6L9.8 9.8L11.6 12.2L12.8 11L16.4 14.6ZM15.125 7.7C15.125 8.38345 14.571 8.9375 13.8875 8.9375C13.204 8.9375 12.65 8.38345 12.65 7.7C12.65 7.01655 13.204 6.4625 13.8875 6.4625C14.571 6.4625 15.125 7.01655 15.125 7.7Z",
    fill: "#6ABC6D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6667 5.66667H6.33333C5.96514 5.66667 5.66667 5.96514 5.66667 6.33333V15.6667C5.66667 16.0349 5.96514 16.3333 6.33333 16.3333H15.6667C16.0349 16.3333 16.3333 16.0349 16.3333 15.6667V6.33333C16.3333 5.96514 16.0349 5.66667 15.6667 5.66667ZM6.33333 5C5.59695 5 5 5.59695 5 6.33333V15.6667C5 16.403 5.59695 17 6.33333 17H15.6667C16.403 17 17 16.403 17 15.6667V6.33333C17 5.59695 16.403 5 15.6667 5H6.33333Z",
    fill: "#313131"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6441_460032"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperimentImaged);
export default __webpack_public_path__ + "static/media/Experiment_Imaged.446ade97c6b913c4bc068879c2b85983.svg";
export { ForwardRef as ReactComponent };